import BaseService from "./Base.Service";

class CompanyService extends BaseService {
	constructor() {
		super("companies");
	}

	async getCompanyData() {
        try {
            const { data } = await this.conn.axios.get(`/companies/company-data`);
            return data;
        } catch (err) {
            return this.sendError("Erros foram encontrados ao buscar empresa", false, err);
        }
    }

    // PUT da empresa ativa com o erro do back no toast (CNPJ inválido ou já cadastrado,
    // logo recusado). O update da base engole o erro.
    async save(data, id) {
        try {
            const response = await this.conn.axios.put(`/companies/${id}`, data);
            return response.data;
        } catch (err) {
            if (err?.response?.status === 413) {
                return this.sendError("Os logos passam do tamanho aceito. Envie imagens de até 1 MB.", false);
            }
            return this.sendError("Erro ao salvar os dados da empresa", false, err);
        }
    }

    // Nova empresa, independente da atual, com o usuário logado como ADM
    async createCompany(companyData) {
        try {
            const { data } = await this.conn.axios.post(`/companies`, companyData);
            return data;
        } catch (err) {
            return this.sendError("Erro ao criar a empresa", false, err);
        }
    }
}

export default CompanyService;
